import { PageSection } from "../../components/PageSection";

import { AboutPortrait } from "./AboutPortrait";

export const About = () => {
  return (
    <PageSection darkMode portrait={<AboutPortrait />}>
      <h2>About Me</h2>
      <p>
        I'm a full-stack software developer, urban hiker, and voracious reader.
        I work as a Senior Software Engineer for{" "}
        <a href="https://www.amplify.com/" target="_blank" rel="noreferrer">
          Amplify
        </a>
        , and I live in Brooklyn with my two dogs.
      </p>
    </PageSection>
  );
};
